import { Enviroment } from "../../../enviroments";
import CookieService from "../../autenticacao/CookieService";
import { Api } from "../axios-config"

export type TStatsOptions = {
    codigo: number;
    label: string;
    peso: number;
}

export interface ILstDrop {
    codigo: number;
    label: string;
}

//#region Picks
type TDraftPicksComTotalCount = {
    data: IDadosRetornoDraftPicks;
    totalCount: number;
}

export interface IDadosRetornoDraftPicks {
    dado: IDetalheDraftPicks[];
    numeroPagina: number;
    tamanhoPagina: number;
    totalPaginas: number;
    totalRegistros: number;
    statusHTTP: number;
    status: number;
}

export interface IDetalheDraftPicksTable {
    id?: number;
    codigo: number;
    caminho_Logo_Franquia_Dono: string;
    nome_Franquia_Dono: string;
    caminho_Logo_Franquia_Original: string;
    nome_Franquia_Original: string;
    nome_Jogador_Escolhido: string;
    foto_Jogador_Escolhido: string;
    codigo_Franquia_Original: number;
    codigo_Franquia_Dono: number;
    codigo_Temporada: number;
    rodada: number;
    posicao_Final: number;
}




export interface IDetalheDraftPicks {
    id?: number;
    codigo: number;
    codigo_Franquia_Original: number;
    codigo_Franquia_Dono: number;
    codigo_Temporada: number;
    rodada: number;
    posicao_Final: number;
    codigo_Jogador_Escolhido: number;
    loteria: boolean;
    logo_Franquia_Dono: string;
    caminho_Logo_Franquia_Dono: string;
    nome_Franquia_Dono: string;
    nome_Franquia_Original: string;
    nome_Jogador_Escolhido: string;
    foto_Jogador_Escolhido: string;
    logo_Franquia_Original: string;
    caminho_Logo_Franquia_Original: string;
    dtCriacao: Date;
    codUsuCriacao: number;
}

export interface IDadosPorcentagemEscolha {
    codigo_Franquia_Original: number;
    codigo_Franquia_Dono: number;
    logo_Franquia_Dono: string;
    nome_Franquia_Dono: string;
    logo_Franquia_Original: string;
    nome_Franquia_Original: string;
    porcentagem_Primeira_Escolha: string;
}


export interface IDadosRetornoPorcentagemEscolha {
    dado: IDadosPorcentagemEscolha[];
    erros: string;
    mensagem: string;
    processado: boolean;
    status: number;
    statusHTTP: number;
}



export interface IDadosRetornoEdicao {
    dado: IDetalheDraftPicks;
    erros: string;
    mensagem: string;
    processado: boolean;
    status: number;
    statusHTTP: number;
}

//#endregion Picks

//#region Salarios
export interface IDetalheDraftSalario {
    codigo: number;

}

export interface IDraftSalario {
    codigo: number;
    nome: string;
    codigo_liga: number;
}

export interface IDadosDraftSalario {
    // Codigo_Franquia : number;
    // Codigo_Jogador : number;
    // nome_Jogador : string;
    // foto_Jogador : string;
    // posicao_Jogador : string;
    // salario_1 : string;
    // salario_2 : string;
    // salario_3 : string;
    // salario_4 : string;
    // salario_5 : string;
    // posicao_1 : string;
    // posicao_2 : string;
    // posicao_3 : string;
    // contundido : boolean;
    // dtContusao : Date;
    // dtRetorno_Contusao: Date;
    // draftado: number;
    // fora_NBA: boolean;
    // restrito: boolean;
    // dtCriacao: Date;
    // codUsuCriacao: number;
}

export interface IListagemDraftSalario {
    codigo: number;
    // nome: string;
    // franquia_Franquia: string;
    // codigo_Usuario: number;
    // codUsuCriacao: number;
    // codigo_Liga: number;
    // logo: string; //"https://cdn.nba.com/headshots/nba/latest/1040x760/1630173.png"
    // dtCriacao: Date;
    // situacao: number;
    // cap_Maximo: string;
    // espaco_Maximo: string;
    // uniforme: string; //imagem
    // codigo_Divisao: number;
    // comissario: boolean;
}

export interface IDadosRetornoListaDraftSalarios {
    dado: IListagemDraftSalario[];
    numeroPagina: number;
    tamanhoPagina: number;
    totalPaginas: number;
    totalRegistros: number;
    statusHTTP: number;
    status: number;
}


type TDraftSalarioComTotalCount = {
    data: IDadosRetornoListaDraftSalarios;
    totalCount: number;
}
//#endregion Salarios


//#region Escolhas 

// type TDraftEscolhasComTotalCount = {
//     data: IDadosRetornoDraftEscolhas;
//     totalCount: number;
// }

export interface IDadosRetornoDraftEscolhas {

    codigo: number;
    codigo_Franquia_Original: number;
    rodada: number;
    codigo_Jogador_Escolhido: number;
    nome_Jogador_Escolhido: string;
    foto_Jogador_Escolhido: string;
    dtCriacao: Date;
    codUsuCriacao: number;
}

export interface IDadosEscolhasJogador {

    codigo_Franquia: number;
    nome_Franquia: string;
    codigo_Jogador: number;
    nome_Jogador: string;
    foto_Jogador: string;
    salario1: string;
    salario2: string;
    salario3: string;
    salario4: string;
    salario5: string;
    stats_Liga: IDadosStats[];

}

export interface IDadosRetornoJogador {
    dado: IDadosEscolhasJogador;
    erros: string;
    mensagem: string;
    processado: boolean;
    status: number;
    statusHTTP: number;
}
export interface IDadosStats {
    codigo: number;
    nome: string;
    peso_Padrao: number;
    positiva: boolean;
    situacao: boolean;
    dtCriacao: Date;
    codUsuCriacao: Number;
    descricao: string;
}


type TJogadoresDraftComTotalCount = {
    data: IDadosRetornoJogador;
    totalCount: number;
}

export interface IListagemJogador {
    codigo: number;
    nome: string;
    ativo: boolean;
    cidade_Franquia_Atual: string;
    codUsuCriacao: number;
    codigo_Franquia_Atual: number;
    codigo_NBA: number;
    dtCriacao: Date;
    foto: string; //"https://cdn.nba.com/headshots/nba/latest/1040x760/1630173.png"
    franquia_Atual: string; //"Toronto Raptors"
    games_Played_Flag: string; //"Y"
    other_League_Experience: string;
    primeiro_Nome: string; // " Precious"
    sigla_Franquia_Atual: string; //"TOR"
    situacao: number;
    ultimo_Nome: string;
    posicao: string;

}

type TTabelaDraftJogadoresComTotalCount = {
    data: IDadosRetornoTabelaDraftJogadores;
    totalCount: number;
}

export interface IDadosRetornoTabelaDraftJogadores {
    dado: IListagemTabelaPicks[];
    erros: string;
    mensagem: string;
    processado: boolean;
    status: number;
    statusHTTP: number;
}


export interface IListagemTabelaPicks {
    escolha: number;
    codigo_Franquia: number;
    nome_Franquia: string;
    foto_Franquia: string;
    codigo_Jogador?: number;
    nome_Jogador: string;
    foto_Jogador: string;
    escolha_Atual: boolean;
    data_Escolha_Inicio?: Date;
    data_Escolha_Fim?: Date;
}


type TTabelaDraftHistoricoPicksComTotalCount = {
    data: IDadosRetornoTabelaHitoricoPicks;
    totalCount: number;
}

export interface IDadosRetornoTabelaHitoricoPicks {
    dado: IListagemTabelaHitoricoPicks[];
    erros: string;
    mensagem: string;
    processado: boolean;
    status: number;
    statusHTTP: number;
}


export interface IListagemTabelaHitoricoPicks {
    escolha: number;
    codigo_Franquia_Dono: number;
    nome_Franquia_Dono: string;
    foto_Franquia_Dono: string;
    codigo_Franquia_Origem: number;
    nome_Franquia_Origem: string;
    foto_Franquia_Origem: string;
    codigo_Jogador?: number;
    nome_Jogador: string;
    foto_Jogador: string;
    escolha_Atual: boolean;
    data_Escolha_Inicio?: Date;
    data_Escolha_Fim?: Date;
}

export interface IDadosSalvarJogadorDraftInicial {
    codigo_Franquia_Dono: number;
    codigo_Liga: number;
    posicao_Geral: number; //numero da escolha
    codigo_Jogador_Escolhido: number;
    codUsuCriacao: number;

}


export interface IDadosSalvarJogadorDraftCalouros {
    codigo_Franquia_Dono: number;
    codigo_Temporada: number;
    posicao_Final: number;
    codigo_Jogador_Escolhido: number;
    codUsuCriacao: number;

}


export interface IDadosRetornoDadosSalariosCalouros {
    dado: IDadosSalarioCalouros[];
    erros: string;
    mensagem: string;
    processado: boolean;
    status: number;
    statusHTTP: number;
}


export interface IDadosSalarioCalouros {
    codigo?: number;
    codigo_Franquia_Origem: number;
    nome_Franquia_Origem: string;
    logo_Franquia_Origem: string;
    codigo_Franquia_Dono: number;
    nome_Franquia_Dono: string;
    logo_Franquia_Dono: string;
    pick: number;
    Ano1: string;
    descricao_Ano1: string;
    Ano2: string;
    descricao_Ano2: string;
    Ano3: string;
    descricao_Ano3: string;
    Ano4: string;
    descricao_Ano4: string;
    Ano5: string;
    descricao_Ano5: string;
    Ano6: string;
    descricao_Ano6: string;
    tipo_Salario1: number;
    tipo_Salario2: number;
    tipo_Salario3: number;
    tipo_Salario4: number;
    tipo_Salario5: number;
    tipo_Salario6: number;

}

export interface IDadosRetornoSorteioCalouro {
    dado: IDaddosDraftSorteioCalouro;
    erros: string;
    mensagem: string;
    processado: boolean;
    status: number;
    statusHTTP: number;
}

export interface IDadosSorteio {
    codigo_Liga: number;
    codigo_Temporada: number;
    codigo_Usuario: number;
}

export interface IDadosSorteioCalouro {
    codigo_Liga: number;
    codigo_Temporada: number;
    codigo_Usuario: number;
    espelhada: boolean;
}

export interface IDaddosDraftSorteioCalouro {
    data_Proximo_Sorteio: Date;
    sorteio_Finalizado: boolean;
    sorteio_Realizado: boolean;
    informacoes_Loteria: IDetalheDraftSorteioPicks[]
}

export interface IDetalheDraftSorteioPicks {
    codigo: number;
    codigo_Liga: number;
    codigo_Temporada: number;
    codigo_Pick: number;
    posicao_Final: number;
    numero_Sorteado?: number;
    data_Liberacao: Date;
    calouro: boolean;
    codigo_Franquia_Original: string;
    nome_Franquia_Original: string;
    logo_Franquia_Original: string;
    codigo_Franquia_Dono: string;
    nome_Franquia_Dono: string;
    logo_Franquia_Dono: string;
}

export interface IDadosRetornoSorteioInicial {
    dado: IDaddosDraftSorteioInicial;
    erros: string;
    mensagem: string;
    processado: boolean;
    status: number;
    statusHTTP: number;
}

export interface IDaddosDraftSorteioInicial {
    data_Proximo_Sorteio: Date;
    sorteio_Finalizado: boolean;
    sorteio_Realizado: boolean;
    informacoes_Loteria: IDetalheDraftSorteioPicks[]
}

//#endregion

export interface IDadosPreferenciaJogadorDraft {
    codigo: number;
    codigo_Liga: number;
    codigo_Temporada: number;
    codigo_Franquia: number;
    codigo_Jogador: number;
    ordem: number;
    nome_Jogador?: string;
    calouro: boolean;
    codUsuCriacao: number;
}

export interface IDadosPreferenciaJogadorDraftEscolha {
    codigo?: number;
    codigo_Liga?: number;
    codigo_Temporada?: number;
    codigo_Franquia?: number;
    ordem: number;
    foto_Jogador: string;
    codigo_Jogador: number;
    nome_Jogador: string;
    calouro: boolean;
}

export interface IDadosRetornoDraftPreferencial {
    dado: IDadosPreferenciaJogadorDraftEscolha[];
    erros: string;
    mensagem: string;
    processado: boolean;
    status: number;
    statusHTTP: number;
}

const getSalariosDraft = async (page = 1, codigo_Liga: number, codigo_Temporada: number, filter = ''): Promise<TDraftPicksComTotalCount> => {
    const token = CookieService.get("access_token");

    const { data, headers } = await Api.get(`liga/draft/salario`, {
        headers: {
            "Access-Control-Allow-Origin": "*",
            "chavesessao": token
        },
        params: {
            Codigo_Liga: codigo_Liga,
            Codigo_Temporada: codigo_Temporada,
            NumeroPagina: page,
            TamanhoPagina: 30,
            Filtro: null,
            Filtro2: filter
        }
    });

    return {
        data,
        totalCount: Number(headers['x-total-count'] || Enviroment.LIMITE_DE_LINHAS),
    };
}

const getDraftSalariosById = async (codigo: number): Promise<IDetalheDraftSalario> => {
    const token = CookieService.get("access_token");
    const { data } = await Api.get<IDetalheDraftSalario>(`/draft/salarios/${codigo}`, {
        headers: {
            "Access-Control-Allow-Origin": "*",
            "chavesessao": token
        }
    });
    return data;
}

const getDraftPorcentagemEscolhaById = async (codigoliga: number): Promise<IDadosRetornoPorcentagemEscolha> => {
    const token = CookieService.get("access_token");
    const { data } = await Api.get<IDadosRetornoPorcentagemEscolha>(`draft/calouro/loteria/porcentagem/${codigoliga}`, {
        headers: {
            "Access-Control-Allow-Origin": "*",
            "chavesessao": token
        }
    });
    return data;
}

const getDraftSorteioById = async (codigoLiga: number): Promise<IDadosRetornoSorteioCalouro> => {
    const token = CookieService.get("access_token");
    const { data } = await Api.get<IDadosRetornoSorteioCalouro>(`/draft/calouro/loteria/sorteio/${codigoLiga}`, {
        headers: {
            "Access-Control-Allow-Origin": "*",
            "chavesessao": token
        }
    });
    return data;
}

const getPicksDraft = async (page = 1, codigo_Liga: number, codigo_Temporada: number, filter = ''): Promise<TDraftPicksComTotalCount> => {
    const token = CookieService.get("access_token");

    const { data, headers } = await Api.get(`liga/draft/picks`, {
        headers: {
            "Access-Control-Allow-Origin": "*",
            "chavesessao": token
        },
        params: {
            Codigo_Liga: codigo_Liga,
            Codigo_Temporada: codigo_Temporada,
            NumeroPagina: page,
            TamanhoPagina: 30,
            Filtro: null,
            Filtro2: filter
        }
    });

    return {
        data,
        totalCount: Number(headers['x-total-count'] || Enviroment.LIMITE_DE_LINHAS),
    };
}

const getByIdTemporada = async (codigo: number): Promise<IDadosRetornoDraftPicks> => {
    const token = CookieService.get("access_token");
    const { data } = await Api.get<IDadosRetornoDraftPicks>(`/franquia/liga/${codigo}`, {
        headers: {
            "Access-Control-Allow-Origin": "*",
            "chavesessao": token
        }
    });
    return data;
}

const getByIdUsuario = async (): Promise<TDraftSalarioComTotalCount> => {
    const user = CookieService.get("access_user");
    const token = CookieService.get("access_token");
    const { data, headers } = await Api.get(`/franquia/usuario/${user.codUsuario}`, {
        headers: {
            "Access-Control-Allow-Origin": "*",
            "chavesessao": token
        }
    });
    return {
        data,
        totalCount: Number(headers['x-total-count'] || Enviroment.LIMITE_DE_LINHAS),
    };
}

const Create = async (dados: Omit<IDetalheDraftSalario, "codigo">): Promise<number> => {

    const token = CookieService.get("access_token");
    const { data } = await Api.post<IDetalheDraftSalario>(`/draft`, dados, {
        headers: {
            "Access-Control-Allow-Origin": "*",
            "chavesessao": token
        }
    });
    return data.codigo;
}

const CreatePreferenciaDraft = async (dados: Omit<IDadosPreferenciaJogadorDraft, "codigo">): Promise<number> => {

    const token = CookieService.get("access_token");
    const { data } = await Api.post<IDadosPreferenciaJogadorDraft>(`/draft/jogador/preferencia`, dados, {
        headers: {
            "Access-Control-Allow-Origin": "*",
            "chavesessao": token
        }
    });
    return data.codigo;
}

const updateById = async (codigo: number, dados: IDetalheDraftSalario): Promise<void> => {
    const token = CookieService.get("access_token");
    await Api.put<IDetalheDraftSalario>(`/draft/${codigo}`, dados, {
        headers: {
            "Access-Control-Allow-Origin": "*",
            "chavesessao": token
        }
    });
}

const updateDadosDraftInicial = async (dados: IDadosSalvarJogadorDraftInicial): Promise<void> => {
    const token = CookieService.get("access_token");
    await Api.put<IDetalheDraftSalario>(`draft/inicial/pickar`, dados, {
        headers: {
            "Access-Control-Allow-Origin": "*",
            "chavesessao": token
        }
    });
}


const updateDadosDraftCalouros = async (dados: IDadosSalvarJogadorDraftCalouros): Promise<void> => {
    const token = CookieService.get("access_token");
    await Api.put<IDetalheDraftSalario>(`draft/pickar`, dados, {
        headers: {
            "Access-Control-Allow-Origin": "*",
            "chavesessao": token
        }
    });
}

const deleteById = async (codigo: number): Promise<void> => {
    const token = CookieService.get("access_token");
    await Api.delete(`/draft/${codigo}`, {
        headers: {
            "Access-Control-Allow-Origin": "*",
            "chavesessao": token
        }
    });
}

const getDadosJogadorSelecionadoInicial = async (codigo_jogador: number, codigo_Franquia: Number, escolhaAtual: number): Promise<IDadosRetornoJogador> => {
    const token = CookieService.get("access_token");
    const { data } = await Api.get<IDadosRetornoJogador>(`/draft/detalhes/inicial/${codigo_jogador}/${codigo_Franquia}/${escolhaAtual}`, {
        headers: {
            "Access-Control-Allow-Origin": "*",
            "chavesessao": token
        }
    });
    return data;
}

const getDadosJogadorSelecionadoCalouro = async (codigo_jogador: number, codigo_Franquia: Number): Promise<IDadosRetornoJogador> => {
    const token = CookieService.get("access_token");
    const { data } = await Api.get<IDadosRetornoJogador>(`/draft/detalhes/calouro/${codigo_jogador}/${codigo_Franquia}`, {
        headers: {
            "Access-Control-Allow-Origin": "*",
            "chavesessao": token
        }
    });
    return data;
}

const getDadosSalarioCalouros = async (codigoLiga: number, codigoTemporada: number, codigoFranquia: number, rodada: number): Promise<IDadosRetornoDadosSalariosCalouros> => {
    const token = CookieService.get("access_token");
    const { data } = await Api.get<IDadosRetornoDadosSalariosCalouros>(`/draft/calouro/salario`, {
        headers: {
            "Access-Control-Allow-Origin": "*",
            "chavesessao": token
        },
        params: {
            Codigo_Liga: codigoLiga,
            Codigo_Temporada: codigoTemporada,
            Codigo_Franquia_Dono: codigoFranquia > 0 ? codigoFranquia : null,
            Rodada: rodada > 0 ? rodada : null,
        }
    });
    return data;
}

const getAllPorLiga = async (codigoLiga: number): Promise<TJogadoresDraftComTotalCount> => {
    const token = CookieService.get("access_token");
    const { data, headers } = await Api.get(`/draft/picks/${codigoLiga}`, {
        headers: {
            "Access-Control-Allow-Origin": "*",
            "chavesessao": token
        }
    });

    return {
        data,
        totalCount: Number(headers['x-total-count'] || Enviroment.LIMITE_DE_LINHAS),
    };
}

const getBuscarTabelaDraft = async (codigoLiga: number, codigoTemporada: Number): Promise<TTabelaDraftJogadoresComTotalCount> => {

    const token = CookieService.get("access_token");
    const { data, headers } = await Api.get(`/draft/picks/${codigoLiga}/${codigoTemporada}`, {
        headers: {
            "Access-Control-Allow-Origin": "*",
            "chavesessao": token
        }
    });

    return {
        data,
        totalCount: Number(headers['x-total-count'] || Enviroment.LIMITE_DE_LINHAS),
    };
}

const getBuscarPicksDraftLigaResumoCalouros = async (codigoLiga: number, codigoTemporada: Number): Promise<TTabelaDraftJogadoresComTotalCount> => {

    const token = CookieService.get("access_token");
    const { data, headers } = await Api.get(`/draft/resumo/picks/${codigoLiga}/${codigoTemporada}`, {
        headers: {
            "Access-Control-Allow-Origin": "*",
            "chavesessao": token
        }
    });

    return {
        data,
        totalCount: Number(headers['x-total-count'] || Enviroment.LIMITE_DE_LINHAS),
    };
}

const getBuscarHitoricoLigaCalouros = async (codigoLiga: number, codigoTemporada: Number): Promise<TTabelaDraftHistoricoPicksComTotalCount> => {

    const token = CookieService.get("access_token");
    const { data, headers } = await Api.get(`/draft/historico/picks/${codigoLiga}/${codigoTemporada}`, {
        headers: {
            "Access-Control-Allow-Origin": "*",
            "chavesessao": token
        }
    });

    return {
        data,
        totalCount: Number(headers['x-total-count'] || Enviroment.LIMITE_DE_LINHAS),
    };
}

const getBuscarHitoricoLigaInicial = async (codigoLiga: number, codigoTemporada: Number): Promise<TTabelaDraftHistoricoPicksComTotalCount> => {

    const token = CookieService.get("access_token");
    const { data, headers } = await Api.get(`/draft/inicial/historico/picks/${codigoLiga}/${codigoTemporada}`, {
        headers: {
            "Access-Control-Allow-Origin": "*",
            "chavesessao": token
        }
    });

    return {
        data,
        totalCount: Number(headers['x-total-count'] || Enviroment.LIMITE_DE_LINHAS),
    };
}

const getBuscarPicksDraftLigaResumoInicial = async (codigoLiga: number, codigoTemporada: Number): Promise<TTabelaDraftJogadoresComTotalCount> => {

    const token = CookieService.get("access_token");
    const { data, headers } = await Api.get(`/draft/inicial/resumo/picks/${codigoLiga}/${codigoTemporada}`, {
        headers: {
            "Access-Control-Allow-Origin": "*",
            "chavesessao": token
        },

    });

    return {
        data,
        totalCount: Number(headers['x-total-count'] || Enviroment.LIMITE_DE_LINHAS),
    };
}

const updateSorteio = async (dados: IDadosSorteio): Promise<void> => {
    const token = CookieService.get("access_token");
    //const user = CookieService.get("access_user");

    //dados = { ...dados, codigo_Usuario: user.codUsuario };

    await Api.put<IDadosSorteio>(`/draft/calouro/loteria/sorteio`, dados, {
        headers: {
            "Access-Control-Allow-Origin": "*",
            "chavesessao": token
        }
    });
}

const getDraftSorteioInicialById = async (codigoLiga: number): Promise<IDadosRetornoSorteioInicial> => {
    const token = CookieService.get("access_token");
    const { data } = await Api.get<IDadosRetornoSorteioInicial>(`/draft/inicial/loteria/sorteio/${codigoLiga}`, {
        headers: {
            "Access-Control-Allow-Origin": "*",
            "chavesessao": token
        }
    });
    return data;
}

const updateSorteioIncial = async (dados: IDadosSorteio): Promise<void> => {
    const token = CookieService.get("access_token");
    //const user = CookieService.get("access_user");

    //dados = { ...dados, codigo_Usuario: user.codUsuario };

    await Api.put<IDadosSorteio>(`/draft/inicial/loteria/sorteio`, dados, {
        headers: {
            "Access-Control-Allow-Origin": "*",
            "chavesessao": token
        }
    });
}

const getDraftPreferencialCalouro = async (codigoLiga: number, codigoTemporada: number, codigoFranquia: number): Promise<IDadosRetornoDraftPreferencial> => {
    const token = CookieService.get("access_token");
    const { data } = await Api.get<IDadosRetornoDraftPreferencial>(`draft/jogador/preferencia/calouro/${codigoLiga}/${codigoTemporada}/${codigoFranquia}`, {
        headers: {
            "Access-Control-Allow-Origin": "*",
            "chavesessao": token
        }
    });
    return data;
}

const getDraftPreferencialInicial = async (codigoLiga: number, codigoTemporada: number, codigoFranquia: number): Promise<IDadosRetornoDraftPreferencial> => {
    const token = CookieService.get("access_token");
    const { data } = await Api.get<IDadosRetornoDraftPreferencial>(`draft/jogador/preferencia/inicial/${codigoLiga}/${codigoTemporada}/${codigoFranquia}`, {
        headers: {
            "Access-Control-Allow-Origin": "*",
            "chavesessao": token
        }
    });
    return data;
}



// const CreateEscolhaJogador = async (codigoLiga: number, codigoTemporada: number, codigoJogador: number): Promise<number> => {

//     const token = CookieService.get("access_token");
//     const { data } = await Api.post<IDetalheDraftSalario>(`/draft`, dados, {
//         headers: {
//             "Access-Control-Allow-Origin": "*",
//             "chavesessao": token
//         }
//     });
//     return data.codigo;
// }

export const DraftService = {
    getBuscarSalariosDraft: getSalariosDraft,
    getDraftSalariosById,
    Create,
    updateById,
    deleteById,
    getByIdTemporada,
    getByIdUsuario,
    getBuscarPicksDraft: getPicksDraft,
    getDadosJogadorSelecionadoInicial,
    getDadosJogadorSelecionadoCalouro,
    getBuscarTabelaDraft,
    getBuscarPicksDraftLigaResumoCalouros,
    getBuscarPicksDraftLigaResumoInicial,
    updateDadosDraftInicial,
    updateDadosDraftCalouros,
    getAllPorLiga,
    getBuscarHitoricoLigaCalouros,
    getBuscarHitoricoLigaInicial,
    getDadosSalarioCalouros,
    getDraftSorteioById,
    updateSorteio,
    getDraftPorcentagemEscolhaById,
    getDraftSorteioInicialById,
    updateSorteioIncial,
    getDraftPreferencialCalouro,
    getDraftPreferencialInicial,
    CreatePreferenciaDraft


}